import * as React from 'react';

import styled from 'styled-components';

/* eslint-disable */
import { Typography } from 'components/DesignSystemV2/Typography';
import { withMarketingSection } from 'components/withMarketingSection';
import { withHomePageSection } from 'components/withHomePageSection';
import { deviceBreakpoints } from 'utils/hooks/useDeviceQuery.hook';
import { fromScreen } from 'utils/media-query/responsive.util';

import { HeadingContainer } from '../HeadingContainer';
import IconCheck from './icons/IconCheck';

const Main = styled.div`
  .border-box {
    display: grid;
    border: 1px solid #d2d3d9;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 24px;
    gap: 12px;
  }
  .list-item {
    display: grid;
    align-items: base-line;
    grid-auto-flow: column;
    grid-template-columns: max-content;
    gap: 8px;
    .list-item-icon {
      font-size: 20px;
      line-height: 0;
    }
    .list-item-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  ${fromScreen(776)} {
    .border-box {
      grid-template-columns: 1fr 1fr;
      gap: 12px 24px;
    }
    .section-title {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const WhatYouWillGet = withHomePageSection(
  props => {
    const { level } = props;
    const whatYouWillGets = {
      whatYouGet1: level.whatYouGet1,
      whatYouGet2: level.whatYouGet2,
      whatYouGet3: level.whatYouGet3,
      whatYouGet4: level.whatYouGet4,
      whatYouGet5: level.whatYouGet5,
      whatYouGet6: level.whatYouGet6,
      whatYouGet7: level.whatYouGet7,
      whatYouGet8: level.whatYouGet8
    };
    const listWhatYouWillGet = Object.keys(whatYouWillGets).filter(key =>
      Boolean(whatYouWillGets[key])
    );
    return (
      <Main id="what-you-will-get">
        <HeadingContainer>
          <Typography
            variant="bold/20-28"
            desktopVariant="bold/24-32"
            className="section-title"
            v3
            as="h2"
          >{`Bạn sẽ đạt được gì sau khóa học`}</Typography>
        </HeadingContainer>
        {listWhatYouWillGet.length > 0 && (
          <div className="border-box">
            {listWhatYouWillGet.map(key => {
              const value = whatYouWillGets[key];
              return (
                <div className="list-item" key={key}>
                  <div className="list-item-icon">
                    <IconCheck />
                  </div>
                  <div className="list-item-text">{value}</div>
                </div>
              );
            })}
          </div>
        )}
      </Main>
    );
  },
  { selfish: true }
);

WhatYouWillGet.propTypes = {};
